import Collapse from '@material-ui/core/Collapse';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import BusinessIcon from '@material-ui/icons/Business';
import CheckIcon from '@material-ui/icons/Check';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LockIcon from '@material-ui/icons/Lock';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import SettingsIcon from '@material-ui/icons/Settings';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { HasPermissions } from '../../components/HasPermissions';
import { useMiaSelector } from '../../components/hooks';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { isItOverriddenByType, isRsmOfAnySalesDist } from '../../ducks/auth';
import { uiActionCreators } from '../../ducks/ui';
import { getUrl, NavTypes, NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';

interface ISalesMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let SalesMenu: React.FunctionComponent<ISalesMenuProps> = ({
  collapsed,
  menuClassName,
  onExpandClick,
  onNavClick,
  navType,
  currentLocation
}) => {
  const dispatch = useDispatch();
  const showInfoCallDialog = React.useCallback(() => dispatch(uiActionCreators.showInfoCallDialog()), []);
  const isRsmOrAdmin = useMiaSelector(state => isRsmOfAnySalesDist(state));
  const isNavItOverridden = useMiaSelector(state => isItOverriddenByType(state, 'sales'));

  React.useEffect(() => {
    if (currentLocation.includes('sales')) {
      onExpandClick('sales');
    }
  }, []);

  return (
    <HasPermissions type="sales">
      <LeftNavHeader
        collapsed={collapsed}
        navType={navType}
        onExpandClick={onExpandClick}
        icon={LocalOfferIcon}
        title="Sales"
        hasWarningColor={isNavItOverridden}
      />
      <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
        <MenuList disablePadding>
          <MenuLink
            icon={<BusinessIcon />}
            to={NavUrls.salesDealers}
            label="Dealers"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.salesDealers === currentLocation}
          />
          <MenuLink
            icon={<LocationOnIcon />}
            to={NavUrls.salesProspects}
            label="Prospects"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.salesProspects === currentLocation}
          />
          <MenuLink
            icon={<PermPhoneMsgIcon />}
            to={getUrl.salesCallList()}
            label="Sales Calls"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.salesCalls === currentLocation}
          />
          <MenuLink
            icon={<CheckIcon />}
            to={NavUrls.salesCompliance}
            label="Compliance"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.salesCompliance === currentLocation}
          />
          {false && (
            <MenuLink
              icon={<InsertChartIcon />}
              to={NavUrls.salesReports}
              label="Reports"
              menuClassName={menuClassName}
              onNavClick={onNavClick}
              isActive={NavUrls.salesReports === currentLocation}
            />
          )}
          <MenuItem className={menuClassName} onClick={showInfoCallDialog}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText secondary="New Informational Call" />
          </MenuItem>
          {isRsmOrAdmin && (
            <MenuLink
              icon={<SettingsIcon />}
              to={NavUrls.salesRegionSettings}
              label="Region Settings"
              menuClassName={menuClassName}
              onNavClick={onNavClick}
              isActive={NavUrls.salesRegionSettings === currentLocation}
            />
          )}
          <HasPermissions type="sales" admin>
            <MenuLink
              icon={<LockIcon />}
              to={NavUrls.salesAdmin}
              label="Admin"
              menuClassName={menuClassName}
              onNavClick={onNavClick}
              isActive={NavUrls.salesAdmin === currentLocation}
            />
          </HasPermissions>
        </MenuList>
      </Collapse>
    </HasPermissions>
  );
};

SalesMenu = React.memo<ISalesMenuProps>(SalesMenu);
export { SalesMenu };
